"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PromoIdentifier = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledPromoIdentifier = require("./styled-promo-identifier");
var _excluded = ["text", "color", "className", "dataTestId", "size"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  text: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].oneOf(['brand', 'black', 'featured']),
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
};
var defaultProps = {
  color: 'black',
  className: undefined,
  dataTestId: undefined,
  size: 'l'
};
var PromoIdentifier = exports.PromoIdentifier = forwardRef(function (_ref, ref) {
  var text = _ref.text,
    color = _ref.color,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledPromoIdentifier.StyledPromoIdentifier, _extends({
    backgroundColor: color,
    className: className,
    "data-testid": dataTestId || 'fuse-promo-identifier-test-id',
    ref: ref
  }, rest), /*#__PURE__*/_react["default"].createElement(_styledPromoIdentifier.StyledPromoIdentifierText, {
    size: _config.text.size[size] || {
      xxs: 'm2',
      m: 'm1',
      l: '1'
    },
    textColor: color,
    type: "paragraph"
  }, text));
});
PromoIdentifier.propTypes = propTypes;
PromoIdentifier.defaultProps = defaultProps;
var _default = exports["default"] = PromoIdentifier;